<template>
  <div>
    <div class="base-wrap clearfix">
      <div class="base-item">
        <em class="label">用款事由：</em>
        <div class="content">
          {{formData.title }}
        </div>
      </div>
      <div class="base-item" v-if="approveType == 5">
        <em class="label">费用部门：</em>
        <div class="content">
          {{formData.department_info?formData.department_info.name:'-/-' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">我方公司：</em>
        <div class="content">
          {{ formData.owner_company_info && formData.owner_company_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item" v-if="approveType != 10">
        <em class="label">对方公司：</em>
        <div class="content">
          {{ formData.other_company_info && formData.other_company_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item" v-if="approveType != 10">
        <em class="label">对方银行：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item" v-if="approveType != 10">
        <em class="label">对方开户行：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.address || '--/--' }}
        </div>
      </div>
      <div class="base-item" v-if="approveType != 10">
        <em class="label">银行备注信息：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.remark || '--/--' }}
        </div>
      </div>
      <div class="base-item" v-if="approveType != 10">
        <em class="label">对方银行账号：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.number || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">最晚付款日期：</em>
        <div class="content">
          {{ formData.last_pay_time || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">币种类型：</em>
        <div class="content" v-if="formData.coin_type">
          {{ coins.constMap.idMap[formData.coin_type].name  || '--/--'}}
        </div>
      </div>
      <div class="base-item">
        <em class="label">总金额：</em>
        <div class="content">
          {{formData.format_sum_money}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">备注信息：</em>
        <div class="content">
          {{formData.remark || '--/--'}}
        </div>
      </div>
      <div class="base-item">
        <em class="label">附件：</em>
        <div class="content" v-if="formData.img_keys&& formData.img_keys.length>0">
          <template v-for="img in formData.img_keys">
            <a style="color: #2f78ff;" :key='img.key'
              :href="`/api/base/download?key=${img.key}`"
              target="_blank">{{img.name}}&nbsp;&nbsp;</a>&nbsp;
          </template>
        </div>
        <div class="content" v-else>--/--</div>
      </div>
    </div>
    <template v-if="approveType ==3 || approveType ==4||approveType ==5||approveType ==6">
      <div class="split_line">
        <i class="el-icon-price-tag"></i><span>帐单详情</span>
        <div class="line"></div>
      </div>
      <el-table size="mini" :data="billsList"
        style="width: 100%; margin-bottom: 20px;">
        <el-table-column
          prop="id"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="month"
          label="月份">
        </el-table-column>
        <el-table-column
          prop="format_sum_money"
          label="总金额">
        </el-table-column>
        <el-table-column
          prop="format_last_money"
          label="未付款金额">
          <template slot-scope="scope">
            {{scope.row.format_last_money||'-/-'}}
          </template>
        </el-table-column>
        <el-table-column
          prop="currency_code"
          label="币种">
          <!-- <template slot-scope="scope">
          {{scope.row.money}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </template> -->
        </el-table-column>
        <el-table-column
          label="文件名">
          <template slot-scope="scope">
            <a :href="item.path" target="_blank" :key="index"
              v-for="(item,index) in scope.row.attachments"
              download>{{item.filename}} <br></a>

          </template>
        </el-table-column>
      </el-table>
    </template>

  </div>
</template>

<script>
import { coins } from '@/const'
import { formatNum } from '@/utils/toTx'
import { getBillDetail } from '@/api/approval'
export default {
  name: 'applaySpendMoneyDetail', // 报销
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    expenseTypes: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    approveType() {
      return this.$route.query.type
    }
  },
  created() {
    console.log('approveType', this.approveType)
    this.getBillDetailHandler()
  },
  methods: {
    formatNum(num) {
      return formatNum(num)
    },
    getBillDetailHandler() {
      let purchase_bill_ids = this.formData.purchase_bill_ids;
      if (!purchase_bill_ids || purchase_bill_ids.length <= 0) return;
      getBillDetail(purchase_bill_ids).then(res => {
        // console.log(res)
        if (res.code != 0) throw new Error(res.message);
        this.billsList = res.data.map(item => {
          return {
            ...item,
            format_sum_money: formatNum(item.money),
            format_last_money: formatNum(item.last_money)
          }
        })

      })
    }
  },
  data() {
    return {
      coins,
      billsList: []
    }
  },
}
</script>
